import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { ProductOffer, UpdateOfferPayload } from 'v2/interfaces/product';
import productService from 'v2/services/product';

type Payload = {
  productId: number;
  offerId: number;
} & UpdateOfferPayload;

export function useUpdateProductOffer(options: UseMutationOptions<ProductOffer, unknown, Payload> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ productId, offerId, ...payload }: Payload) =>
      productService.updateOffer(productId, offerId, payload),
    ...options,
    onSuccess: (...args) => {
      const [, { productId }] = args;
      queryClient.removeQueries({ queryKey: ['product', productId] });
      queryClient.invalidateQueries({ queryKey: ['products', productId, 'offers'] });
      options.onSuccess?.(...args);
    }
  });
}
